import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { setShowDeleteAccountCancelDialog } from "src/redux/slices/AuthSlice";

const DialogContentBox = styled(Box)({
  padding: "24px",
  textAlign: "center",
});

const DeleteAccountCancelRequestDialog = () => {
  const dispatch = useDispatch();
  const showDialog = useSelector((state) => state.auth.showDeleteAccountCancelDialog);

  const handleClose = () => {
    dispatch(setShowDeleteAccountCancelDialog(false));
  };

  const handleSendRequest = () => {
    // Open email client with mailto link
    const subject = encodeURIComponent("delete account request cancel");
    const body = encodeURIComponent("I would like to cancel my account deletion request.");
    const mailtoLink = `mailto:support@beemz.com?subject=${subject}&body=${body}`;
    window.location.href = mailtoLink;
  };

  return (
    <Dialog
      sx={{ "& .MuiDialog-paper": { borderRadius: "12px" } }}
      open={showDialog}
      onClose={handleClose}
    >
      <DialogContent sx={{ p: 0 }}>
        <DialogContentBox>
          {/* Title */}
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              mb: 2,
              color: "#6200EE",
              textTransform: "lowercase",
            }}
          >
            delete account cancel request
          </Typography>

          {/* Description */}
          <Typography
            variant="body1"
            sx={{
              mb: 3,
              color: "#666",
              textTransform: "lowercase",
            }}
          >
            your account delete request is in review. if you want to change your
            request send us a mail by clicking the request button
          </Typography>

          {/* Send Request Button */}
          <Button
            variant="contained"
            fullWidth
            onClick={handleSendRequest}
            sx={{
              textTransform: "lowercase",
              bgcolor: "#6200EE",
              py: 1.5,
              "&:hover": {
                bgcolor: "#5000CC",
              },
            }}
          >
            send request
          </Button>
        </DialogContentBox>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteAccountCancelRequestDialog;
